import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";
// Self-hosted: the production CSP is `default-src 'self'` with no font-src, so
// a Google Fonts request would be blocked outright. See frontend/deploy/nginx.conf.
import "@fontsource-variable/inter";
import "./styles.css";

const rootElement = document.querySelector<HTMLDivElement>("#root");

if (rootElement === null) {
  throw new Error("Mioscape root element is missing");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
